import { db } from '../firebase';
import { 
  collection, 
  doc, 
  getDocs, 
  getDoc, 
  addDoc, 
  updateDoc, 
  deleteDoc, 
  query, 
  where, 
  orderBy, 
  limit, 
  startAfter,
  serverTimestamp 
} from 'firebase/firestore';
import HierarchicalServices from './HierarchicalServices';

/**
 * Generic Firebase service for CRUD operations on collections
 * Example usage:
 * const result = await getItems("books", {
 *   sort: "price", 
 *   order: "asc",
 *   page: 1,
 *   perPage: 10,
 *   filter: { authorId: "123", genre: "fiction" }
 * });
 */
const FirebaseService = {
  getItems: async (collectionName, obj = {}) => {
    return await HierarchicalServices.getItems(collectionName, obj);
  },

  searchItems: async (collectionName, obj = {}) => {
    try {
      let q = collection(db, collectionName);
      const conditions = [];

      // Add search conditions (simplistic implementation)
      // Note: Firebase doesn't support direct text search like json-server's _like
      // For proper text search, consider using Firebase extensions or Cloud Firestore indexes
      Object.entries(obj).forEach(([key, value]) => {
        if (value !== undefined && value !== null && value !== '') {
          // This is a simplistic exact match, not a text search
          conditions.push(where(key, '==', value));
        }
      });

      // Add grade and branch filters if provided
      if (obj.filters) {
        if (obj.filters.grade) {
          conditions.push(where('grade', '==', obj.filters.grade));
        }
        if (obj.filters.branch) {
          conditions.push(where('branch', '==', obj.filters.branch));
        }
      }

      if (conditions.length > 0) {
        q = query(q, ...conditions);
      }

      const querySnapshot = await getDocs(q);
      const items = [];
      querySnapshot.forEach((doc) => {
        items.push({
          id: doc.id,
          ...doc.data()
        });
      });

      return items;
    } catch (e) {
      console.error(`Error searching ${collectionName}:`, e);
      return [];
    }
  },

  getItem: async (collectionName, obj) => {
    return await HierarchicalServices.getItem(collectionName, obj);
  },

  addItem: async (collectionName, obj) => {
    console.log("obj", obj);
    console.log("collectionName", collectionName);
    
    return await HierarchicalServices.addItem(collectionName, obj);
  },


  updateItem: async (collectionName, obj = {}) => {
    return await HierarchicalServices.updateItem(collectionName, obj);
  },

  deleteItem: async (collectionName, obj) => {
    return await HierarchicalServices.deleteItem(collectionName, obj);
  },
};

export default FirebaseService; 